{
  "add": "Idagdag",
  "age": {
    "range": {
      "ADULT": "Matanda",
      "BABY": "Sanggol",
      "CHILD": "Bata",
      "SENIOR": "Senior",
      "TURNING_SENIOR": "Malapit nang Senior",
      "YOUNG_ADULT": "Young Adult",
      "YOUTH": "Kabataan"
    },
    "unknown": "Hindi alam ang edad",
    "years": "Edad {{ years }}"
  },
  "ages": {
    "ADULT": "(21-63) Matanda",
    "BABY": "(0-1) Sanggol",
    "CHILD": "(1-5) Bata",
    "SENIOR": "(65+) Senior",
    "TURNING_SENIOR": "(64) Malapit nang Senior",
    "YOUNG_ADULT": "(19-20) Young Adult",
    "YOUTH": "(6-18) Kabataan"
  },
  "back": "Bumalik",
  "cancel": "I-cancel",
  "childCaregiverStatus": {
    "CAREGIVER": "Oo",
    "NOT_CAREGIVER": "Hindi"
  },
  "citizenshipStatus": {
    "IMMIGRANT": "Maayos na katayuan sa immigration (green card, atbp.)",
    "NOT_ANSWERED": "Mas piniling huwag sumagot",
    "US_CITIZEN": "U.S. Citizen",
    "US_NATIONAL": "U.S. National"
  },
  "clear": "Burahin",
  "clearAddress": "Burahin ang address",
  "clearFilters": "Burahin ang mga Filter",
  "clinic": "Klinika",
  "close": "Isara",
  "continue": "Magpatuloy",
  "dateOfBirth": "Petsa ng kapanganakan",
  "datePicker": {
    "placeholder": "Pumili ng petsa",
    "required": "Pumili ng petsa."
  },
  "datetime": {
    "daysWithCount_one": "{{count}} araw",
    "daysWithCount_other": "{{count}} (na) araw",
    "monthsWithCount_one": "{{count}} buwan",
    "monthsWithCount_other": "{{count}} (na) buwan",
    "yearsWithCount_one": "{{count}} taon",
    "yearsWithCount_other": "{{count}} (na) taon"
  },
  "day": "Araw",
  "delete": "Burahin",
  "discardFormChangesDialog": {
    "cancelButton": "Bumalik sa pag-e-edit",
    "confirmButton": "Umalis pa rin",
    "creating": "paggawa",
    "description": "May mga hindi na-save na pagbabago sa {{entity}} na iyong {{action}}. Kung aalis ka sa pahinang ito, mawawala ang iyong progreso.",
    "entity": "impormasyon",
    "title": "Sigurado ka bang gusto mong umalis?",
    "updating": "pag-e-edit"
  },
  "documentGroups": {
    "PROOF_OF_CITIZENSHIP": "Katibayan ng Immigration",
    "PROOF_OF_EXEMPTION": "Katibayan ng Exemption",
    "PROOF_OF_EXPENSE": "Katibayan ng Gastos",
    "PROOF_OF_IDENTITY": "Katibayan ng Pagkakakilanlan",
    "PROOF_OF_INCOME_AND_EMPLOYMENT": "Katibayan ng Kita at Trabaho",
    "PROOF_OF_INSURANCE": "Katibayan ng Insurance mula sa Amo o Iba Pang Insurance",
    "PROOF_OF_RESIDENCE": "Katibayan ng Tirahan",
    "PROOF_OF_WORK": "Katibayan ng Trabaho",
    "SOCIAL_SECURITY_NUMBER": "Social Security Number"
  },
  "documentTypes": {
    "ALIMONY_PAID": "Bayad sa Alimony",
    "AUTHORIZED_EMPLOYMENT_ID": "ID ng Awtorisadong Trabaho",
    "BANK_STATEMENTS": "Bank statements",
    "BIRTH_CERTIFICATE": "Birth Certificate",
    "CHILDCARE": "Pag-aalaga ng Bata",
    "CHILDS_BIRTH_CERTIFICATE": "Birth Certificate ng Bata",
    "CHILDS_PASSPORT": "Pasaporte ng Bata",
    "COURT_ORDERED_STATEMENTS": "Mga utos mula sa korte",
    "DOCTORS_NOTE": "Sulat mula sa Doktor",
    "DRIVERS_LICENSE": "Driver's License",
    "EXPENSE_OTHER": "Iba pa",
    "FOSTER_CARE_VERIFICATION_LETTER": "Sulat ng Beripikasyon ng Foster Care",
    "GUARDIANSHIP_OR_CUSTODY_PAPERS": "Mga Papeles ng Guardianship o Custody",
    "IMIGRATION_DOCUMENTS_AND_APPROVALS": "Mga Dokumento sa Immigration at Pagpapatibay",
    "INSURANCE_CARD": "Insurance Card",
    "INSURANCE_CARRIER_INFO": "Insurance Carrier - pangalan at address",
    "INSURANCE_POLICY_NUMBER": "Numero ng Polisiya",
    "IRA_CONTRIBUTIONS": "Kontribusyon sa IRA",
    "I_20": "I-20",
    "LETTER_OF_STATEMENT_FROM_EMPLOYER": "Sulat o pahayag mula sa amo",
    "MEDICAL_EXPENSE": "Gastos sa Medikal",
    "MEDICARE_CARD": "Medicare Card",
    "MORTGAGE_STATEMENT": "Mortgage statement",
    "MOVING_EXPENSES": "Gastos sa Paglipat ng Bahay",
    "PASSPORT": "Pasaporte",
    "PAY_STUBS": "Pay stubs (huling 30 araw)",
    "PENSION_STATEMENTS": "Pension statements",
    "PROPERTY_TAX_BILL": "Property Tax Bill",
    "RELEASE_OR_DISCHARGE_PAPERWORK": "Mga Papeles ng Paglaya o Discharge",
    "RENT_RECEIPT_OR_LEASE_AGREEMENT": "Resibo ng Renta o Lease Agreement",
    "SCHOOL_ENROLLMENT_VERIFICATION_OR_TRANSCRIPT": "Beripikasyon ng Enrollment sa Paaralan o Transcript",
    "SIGNED_LETTER": "Pirmadong Sulat",
    "SIGNED_TIMESHEETS": "Pirmadong Timesheet",
    "SNAP_TANF_VERIFICATION_LETTER": "Sulat ng Beripikasyon ng SNAP/TANF",
    "SOCIAL_SECURITY_CARD": "Social Security Card",
    "SSA_STATEMENTS": "SSA statements",
    "SSDI_STATEMENTS": "SSDI statements",
    "STATE_ID": "State ID",
    "STUDENT_LOANS": "Student Loans",
    "TAX_RETURN": "Tax Return (pinakabago)",
    "TRAINING_OR_APPRENTICESHIP_ENROLLMENT_CERTIFICATE": "Certificate ng Enrollment sa Training o Apprenticeship",
    "TREATMENT_PROGRAM_ENROLLMENT_LETTER": "Sulat ng Enrollment sa Treatment Program",
    "TRIBAL_ENROLLMENT_CARD_OR_LETTER": "Tribal Enrollment Card o Sulat",
    "TUITION_FEES": "Bayad sa Eskwela (Tuition)",
    "UNEMPLOYMENT_STATEMENTS": "Unemployment statements",
    "USCIS_ID": "USCIS ID (hindi mamamayan)",
    "UTILITY_BILL": "Utility Bill",
    "VA_DISABILITY_RATING_LETTER": "Sulat ng VA Disability Rating",
    "W2_FORMS": "Mga W-2 Form",
    "descriptions": {
      "ALIMONY_PAID": "Kasunduan sa diborsyo o paghihiwalay",
      "AUTHORIZED_EMPLOYMENT_ID": "Dokumento ng awtorisasyon sa trabaho mula sa USCIS",
      "BANK_STATEMENTS": "Statements ng checking o savings mula sa huling 30 araw",
      "BIRTH_CERTIFICATE": "U.S. birth certificate na may pangalan at petsa ng kapanganakan mo",
      "CHILDCARE": "Bank statement, resibo, o sulat mula sa iyong tagapag-alaga ng bata",
      "CHILDS_BIRTH_CERTIFICATE": "Birth certificate na may pangalan at petsa ng kapanganakan ng iyong anak",
      "CHILDS_PASSPORT": "U.S. passport na may pangalan at petsa ng kapanganakan ng iyong anak",
      "COURT_ORDERED_STATEMENTS": "Utos ng korte para sa child support, alimony, o workers' compensation",
      "DOCTORS_NOTE": "Sulat mula sa doktor na naglalarawan ng kondisyong medikal, kapansanan, o pagbubuntis na pinagbabatayan ng exemption na ito",
      "DRIVERS_LICENSE": "Kasalukuyang lisensya na may pangalan, petsa ng kapanganakan, at address mo",
      "EXEMPTION_SSA_STATEMENTS": "Sulat na nagpapakita ng Social Security benefit ng taong inaalagaan mo",
      "EXEMPTION_SSDI_STATEMENTS": "Sulat na nagpapakita ng disability benefit ng taong inaalagaan mo",
      "EXPENSE_OTHER": "Utos ng korte o nakasulat na kasunduan na nagpapakita ng halaga ng bayad",
      "FOSTER_CARE_VERIFICATION_LETTER": "Sulat mula sa foster care agency ng iyong estado na nagpapatunay sa iyong status at edad",
      "GUARDIANSHIP_OR_CUSTODY_PAPERS": "Utos ng korte o mga papeles ng custody na nagpapakitang ikaw ang legal na tagapag-alaga ng bata",
      "IMIGRATION_DOCUMENTS_AND_APPROVALS": "Work permit, visa, o iba pang dokumento ng USCIS na nagpapakita ng iyong katayuan",
      "IMMIGRATION_BIRTH_CERTIFICATE": "Birth certificate na may pangalan at petsa ng kapanganakan mo",
      "IMMIGRATION_PASSPORT": "Passport na may pangalan at petsa ng kapanganakan mo",
      "INSURANCE_CARD": "Harap at likod ng card na may pangalan ng carrier at numero ng polisiya",
      "INSURANCE_CARRIER_INFO": "Dokumento na may pangalan at address ng kumpanya ng insurance",
      "INSURANCE_POLICY_NUMBER": "Dokumento na nagpapakita ng iyong insurance policy o member ID number",
      "IRA_CONTRIBUTIONS": "Statement mula sa iyong bangko o IRA provider",
      "I_20": "Papel na form mula sa iyong paaralan na nagpapakita na maaari kang mag-aral sa U.S.",
      "LETTER_OF_STATEMENT_FROM_EMPLOYER": "Sulat na nagpapatunay sa iyong trabaho at sahod",
      "MEDICAL_EXPENSE": "Bank statement, bill, o resibo mula sa iyong doktor, ospital, o botika",
      "MEDICARE_CARD": "Medicare card na nagpapakitang naka-enroll ka sa Medicare Part A at/o B",
      "MORTGAGE_STATEMENT": "Mortgage statement sa loob ng huling 60 araw na may address mo",
      "MOVING_EXPENSES": "Mga resibo ng paglipat at sulat mula sa iyong amo",
      "PASSPORT": "U.S. passport na may pangalan at petsa ng kapanganakan mo",
      "PAY_STUBS": "Pay stubs mula sa huling 30 araw na nagpapakita ng kabuuang sahod at amo",
      "PENSION_STATEMENTS": "Statement na nagpapakita ng iyong buwanang halaga ng pension",
      "PROPERTY_TAX_BILL": "Property tax bill na may address mo",
      "RELEASE_OR_DISCHARGE_PAPERWORK": "Mga papeles na nagpapakita ng petsa ng iyong paglaya mula sa kulungan o bilangguan",
      "RENT_RECEIPT_OR_LEASE_AGREEMENT": "Resibo ng renta o lease na nagpapakita ng iyong kasalukuyang address",
      "SCHOOL_ENROLLMENT_VERIFICATION_OR_TRANSCRIPT": "Sulat o transcript na nagpapakitang naka-enroll ka nang hindi bababa sa half-time",
      "SIGNED_LETTER": "Sulat na nagpapatunay sa training, pag-aaral, apprenticeship, o serbisyo sa komunidad",
      "SIGNED_TIMESHEETS": "Mga timesheet na pinirmahan ng iyong employer o supervisor na nagpapakita ng mga oras na nagtrabaho",
      "SNAP_TANF_VERIFICATION_LETTER": "Sulat mula sa iyong SNAP o TANF office na nagpapatunay na nakakatugon ka sa kanilang mga work requirement",
      "SOCIAL_SECURITY_CARD": "Card na may pangalan at 9-digit na Social Security number mo",
      "SSA_STATEMENTS": "Sulat na nagpapakita ng iyong buwanang Social Security benefit",
      "SSDI_STATEMENTS": "Sulat na nagpapakita ng iyong buwanang disability benefit",
      "STATE_ID": "Kasalukuyang state ID card na may pangalan, petsa ng kapanganakan, at address mo",
      "STUDENT_LOANS": "Statement mula sa iyong bangko o loan servicer",
      "TAX_RETURN": "Kumpletong tax return mula noong nakaraang taon",
      "TRAINING_OR_APPRENTICESHIP_ENROLLMENT_CERTIFICATE": "Certificate o sulat na nagpapakitang naka-enroll ka sa isang training o apprenticeship program",
      "TREATMENT_PROGRAM_ENROLLMENT_LETTER": "Sulat na nagpapatunay na naka-enroll ka sa isang programa ng paggamot sa droga o alak",
      "TRIBAL_ENROLLMENT_CARD_OR_LETTER": "Tribal ID card o sulat na nagpapatunay sa iyong pagiging miyembro",
      "TUITION_FEES": "Resibo o bill mula sa iyong paaralan",
      "UNEMPLOYMENT_STATEMENTS": "Sulat na nagpapakita ng iyong lingguhan o buwanang unemployment benefits",
      "USCIS_ID": "Green card, work permit, o certificate ng pagkamamamayan",
      "UTILITY_BILL": "Bill mula sa huling 60 araw para sa kuryente, gas, tubig, o telepono na may address mo",
      "VA_DISABILITY_RATING_LETTER": "Sulat mula sa VA na nagpapakita ng iyong 100% disability rating",
      "W2_FORMS": "Pinakabagong W-2 na nagpapakita ng iyong employer at sahod"
    }
  },
  "documents": {
    "choosePhoto": "Pumili ng Larawan",
    "takePhoto": "Kumuha ng Larawan"
  },
  "done": "Tapos na",
  "edit": "I-edit",
  "email": "Email",
  "error": "Mali",
  "errorFallback": {
    "description": "Nagkaroon ng problema sa pag-load ng page na ito.",
    "resetCta": "Subukan muli",
    "title": "May nagkamali."
  },
  "errors": {
    "appleSsoNotSupported": "Hindi available ang sign in gamit ang Apple. Subukan ang ibang opsyon.",
    "emptyHomeAddress": "Pakilagay at pumili ng iyong address, o piliin ang \"Walang Permanenteng Address\".",
    "emptyMailingAddress": "Pakilagay at pumili ng address para sa sulat, o piliin ang \"Walang Address para sa Sulat\".",
    "googleSsoNotSupported": "Hindi available ang sign in gamit ang Google. Subukan ang ibang opsyon.",
    "invalidEmail": "Maglagay ng valid na email (halimbawa, name@example.com).",
    "selectValidOption": "Pumili ng valid na opsyon.",
    "unableToCreateApplications": "Hindi namin maipadala ang iyong applications. I-check ang internet at subukan muli.",
    "unauthenticated": "Mag-sign in para magpatuloy.",
    "unauthorized": "Wala kang access para mag-sign in. Kung mali ito, sumulat sa support@pointcare.com.",
    "unknown": "May nagkamali. Pakisubukan muli."
  },
  "exit": "Umalis",
  "female": "Babae",
  "filesWithCount_one": "{{count}} file",
  "filesWithCount_other": "{{count}} (na) file",
  "healthInsuranceOrCoverageStatus": {
    "EMPLOYER": "Health insurance mula sa trabaho (employer-sponsored)",
    "MEDICAID": "Medicaid",
    "MEDICARE": "Medicare",
    "OTHER": "Iba pa",
    "PRIVATE": "Pribadong insurance o Marketplace ng ACA",
    "TRICARE": "TRICARE (military health coverage)",
    "VA": "VA Health Care Program"
  },
  "home": "Home",
  "householdMember": "Kasama sa Bahay",
  "listConnector": " at ",
  "listSeparator": ", ",
  "loading": "Nagkakarga...",
  "login": {
    "checkYourEmail": "Suriin ang iyong email na {{email}} para sa sign-in link.",
    "placeholder": "pangalan@halimbawa.com",
    "sendEmail": "Ipadala ang email"
  },
  "longDateFormat": "MMMM D, YYYY",
  "male": "Lalaki",
  "maritalStatus": {
    "COMMON_LAW": "Common Law Marriage",
    "DIVORCED": "Divorced",
    "MARRIED": "Married",
    "NEVER_MARRIED": "Never Married",
    "REGISTERED_DOMESTIC_PARTNER": "Registered Domestic Partner",
    "SEPARATED": "Separated",
    "WIDOWED": "Widowed"
  },
  "marketplace": "Marketplace ng ACA",
  "medicaid": "Medicaid",
  "medicare": "Medicare",
  "medicarePlanType": {
    "ADVANTAGE": "Medicare Advantage (Part C)",
    "NOT_SURE": "Hindi sigurado",
    "ORIGINAL": "Part A at B (Original)"
  },
  "member_one": "{{count}} miyembro",
  "member_other": "{{count}} (na) miyembro",
  "month": "Buwan",
  "next": "Susunod",
  "no": "Hindi",
  "noResults": "Walang nahanap na resulta",
  "noneOfTheAbove": "Wala sa mga nabanggit",
  "ok": "OK",
  "open": "Buksan",
  "or": "o",
  "pagination": {
    "goToFirstPage": "Pumunta sa unang pahina",
    "goToLastPage": "Pumunta sa huling pahina",
    "goToNextPage": "Pumunta sa susunod na pahina",
    "goToPreviousPage": "Pumunta sa nakaraang pahina",
    "morePages": "Higit pang mga pahina",
    "pagination": "Pagination",
    "rowsPerPage": "Linya bawat pahina",
    "rowsResults": "{{from}} hanggang {{to}} ng {{total}} (na) resulta",
    "showingPrefix": "Ipinapakita ang "
  },
  "payFrequency": {
    "ANNUALLY": "Taunan",
    "BI_WEEKLY": "Kada 2 linggo",
    "MONTHLY": "Buwanan",
    "WEEKLY": "Lingguhan"
  },
  "pdfViewer": {
    "loading": "Kinakarga ang dokumento..."
  },
  "program_one": "{{count}} programa",
  "program_other": "{{count}} (na) programa",
  "progressIndicator": "Progreso: {{progress}} ng {{total}} ang tapos na",
  "relationships": {
    "CHILD": "Anak",
    "FOSTER_CHILD": "Foster Child",
    "GRANDCHILD": "Apo",
    "GRANDPARENT": "Lolo/Lola",
    "OTHER": "Iba pa",
    "PARENT": "Magulang",
    "PARTNER": "Katuwang (Partner)",
    "SIBLING": "Kapatid",
    "SPOUSE": "Asawa",
    "STEPCHILD": "Stepchild"
  },
  "required": "Kailangang sagutan ang bahaging ito.",
  "returnToDashboard": "Bumalik sa Dashboard",
  "save": "I-save",
  "saveChanges": "I-save ang mga pagbabago",
  "share": "Ibahagi",
  "sidebar": {
    "title": "Sidebar",
    "toggle": "I-toggle ang sidebar"
  },
  "signOut": "Mag-sign out",
  "skip": "Laktawan",
  "stepIndicator": "Hakbang {{currentStep}} ng {{totalSteps}}",
  "submit": "Isumite",
  "tabs": {
    "home": "Home"
  },
  "taxFilingStatus": {
    "HEAD": "Head of Household",
    "JOINTLY": "Married filing jointly",
    "NON_FILER": "Hindi naghahain (Not filing)",
    "SEPARATELY": "Married filing separately",
    "SINGLE": "Single",
    "WIDOWER": "Qualifying Widow(er) na may Dependent na Anak"
  },
  "theme": "Tema",
  "time": {
    "am": "AM",
    "pm": "PM"
  },
  "undo": "I-undo",
  "unknown": "Hindi alam",
  "uploadButton": {
    "title": "Mag-upload ng File o Kumuha ng Larawan"
  },
  "validation": {
    "atLeastOneOption": "Pumili ng kahit isang opsyon.",
    "genericError": "Hindi iyon gumana. Pakisubukan muli.",
    "invalidCode": "Hindi tugma ang code. I-check ito o humingi ng bago.",
    "invalidEmail": "Maglagay ng valid na email (halimbawa, name@example.com).",
    "invalidNumber": "Maglagay ng valid na numero.",
    "invalidPassword": "Mali ang password. Pakisubukan muli.",
    "invalidPhone": "Maglagay ng 10-digit na numero ng telepono.",
    "invalidSsn": "Ang iyong Social Security Number ay dapat puro numero lang (walang dash o space).",
    "invalidSsnFormat": "Hindi valid ang Social Security Number na iyon. I-check ito at subukang muli.",
    "invalidSsnLength": "Pakilagay ang iyong 9-digit na Social Security Number.",
    "numberMustBeNonNegative": "Maglagay ng numero na zero o mas mataas.",
    "passwordMismatch": "Hindi magkatugma ang mga password.",
    "requiredField": "Pakisagutan ang bahaging ito.",
    "requiredFields": "Pakisagutan ang lahat ng required na bahagi.",
    "requiredNonNegative": "Maglagay ng numero na zero o mas mataas.",
    "requiredPassword": "Pakilagay ang iyong password.",
    "unknown": "May nagkamali. Pakisubukan muli."
  },
  "verifySignInWithEmailLinkScreen": {
    "confirmEmailPrompt": "Ilagay ang iyong email upang makumpleto ang pag-sign in",
    "verify": "I-verify",
    "verifyError": "Hindi namin ma-verify ang iyong sign-in link. Maaaring expired na ito. Pakihingi ng bagong link."
  },
  "whoApplies": "Kanino ito nararapat?",
  "whoIsApplying": "Sino ang nag-a-apply?",
  "year": "Taon",
  "yes": "Oo",
  "zoom": "Zoom",
  "zoomIn": "Zoom In",
  "zoomOut": "Zoom Out",
  "zoomReset": "I-reset ang Zoom"
}
